module.exports = __webpack_public_path__ + "img/sm.bb5c85ec.png";